module.exports = __webpack_public_path__ + "img/logo2.8afe167e.png";